<template>
  <div>
    <div class="row">
      <div class="col-lg-3 filters-wrapper">
        <div class="filters">
          <div class="block block-fx-pop block-mode-loading-oneui filter">
            <div class="block-header block-header-default">
              <h3 class="block-title">Zoeken</h3>
              <div class="block-options">
                <i
                  class="fas fa-question-circle"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Zoek op url van de link en/of de titel van het artikel."
                  data-original-title="Zoek op url van de link en/of de titel van het artikel."
                ></i>
              </div>
            </div>
            <div class="block-content p-0">
              <div class="input-group input-group-lg bg-white">
                <input type="search" class="form-control form-control-alt bg-white border-0 pr-0" placeholder="Zoeken.." v-model="search" />
                <div class="input-group-append">
                  <span class="input-group-text bg-white border-0">
                    <i class="fas fa-search"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="block block-fx-pop block-mode-loading-oneui filter pb-3" v-for="filter in filters" :key="filter.key">
            <div class="block-header block-header-default">
              <h3 class="block-title">{{ filter.name }}</h3>
            </div>
            <div class="block-content p-0">
              <div class="input-group input-group-sm bg-white" v-if="filter.key == 'blog'">
                <input
                  type="text"
                  class="form-control form-control-alt bg-white border-0 pr-0"
                  placeholder="Zoeken.."
                  v-model="filter.search"
                  v-on:keyup="toggleFilterSearch(filter.key, $event)"
                />
                <div class="input-group-append">
                  <span class="input-group-text bg-white border-0">
                    <i class="fas fa-search"></i>
                  </span>
                </div>
              </div>

              <div class="dropdown-item" v-for="data in filter.visible" :key="data.name" v-on:click.stop.prevent="toggleFilter(filter.key, data)">
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    :id="data.value"
                    :name="data.value"
                    :checked="isSelectedFilter(filter.key, data.value)"
                    v-on:change.prevent="toggleFilter(filter.key, data)"
                  />
                  <label class="custom-control-label d-flex align-items-baseline" :for="data.value"
                    >{{ data.name | capitalize }}
                    <i
                      class="fas fa-question-circle ml-2"
                      v-if="data.tooltip"
                      data-toggle="tooltip"
                      data-placement="top"
                      :title="data.tooltip"
                      :data-original-title="data.tooltip"
                    ></i>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-9">
        <div class="sites-wrapper">
          <bs-blog-table-block
            v-for="blog in visibleBlogs"
            :key="blog.id"
            :blog="blog"
            :selectedFilters="selectedFilters"
            :selectedPosts="selectedPosts"
          ></bs-blog-table-block>
        </div>
      </div>
    </div>
    <transition name="custom-classes-transition" enter-active-class="animated bounceInUp fast" leave-active-class="animated bounceOutDown fast">
      <div class="bulk-bar-wrapper d-flex justify-content-center" v-if="selectedPosts.length > 0">
        <div class="bulk-bar d-flex align-items-center justify-content-between bg-primary">
          <div class="bulk-count">{{ this.selectedPosts.length }} artikel{{ this.selectedPosts.length > 1 ? 'en' : '' }} geselecteerd</div>
          <div class="bulk-actions">
            <a
              href="javascript:void(0)"
              class="bulk-action"
              data-toggle="tooltip"
              data-placement="top"
              title="Links verwijderen"
              data-original-title="Links verwijderen"
              v-on:click.prevent="bulkDelete"
            >
              <i class="far fa-trash-alt"></i>
            </a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import Fuse from 'fuse.js';

export default {
  props: ['blogs'],
  data: () => {
    return {
      search: '',
      visibleBlogs: [],
      selectedPosts: [],
      selectedFilters: [],
      filters: {
        blog: {
          search: '',
          key: 'blog',
          name: 'Blog',
          data: [],
          visible: [],
        },
        status: {
          key: 'status_name',
          name: 'Status',
          visible: [
            {
              value: 'Actief',
              name: 'Actief',
            },
            {
              value: 'Binnenkort online',
              name: 'Binnenkort online',
            },
            {
              value: 'Wordt geschreven',
              name: 'Wordt geschreven door tekstschrijver',
            },
            {
              value: 'In afwachting van goedkeuring',
              name: 'In afwachting van goedkeuring',
            },
            {
              value: 'Wacht op tekstschrijver',
              name: 'Wacht op tekstschrijver',
            },
            {
              value: 'Vertraagd',
              name: 'Vertraagd',
            },
            {
              value: 'Aanpassing nodig',
              name: 'Aanpassing nodig'
            }
          ],
        },
      },
    };
  },
  watch: {
    search: function() {
      this.addSearch();
    },
    selectedFilters: function() {
      var selectedFilteredBlogs = this.selectedFilters
        .filter((filter) => {
          return filter.key === 'blog';
        })
        .map((filter) => {
          return this.blogs.find((blog) => blog.id === filter.value);
        });

      this.visibleBlogs = selectedFilteredBlogs.length > 0 ? selectedFilteredBlogs : this.blogs;
    },
    selectedPosts: function() {
      setTimeout(() => {
        window.One.helpers(['core-bootstrap-tooltip']);
      }, 200);
    },
  },
  created() {
    this.visibleBlogs = this.blogs;
    this.filters.blog.data = this.filters.blog.visible = this.blogs.map((blog) => {
      return {
        value: blog.id,
        name: blog.name,
      };
    });
  },
  methods: {
    isSelectedFilter: function(key, value) {
      var index = _.findIndex(this.selectedFilters, (sFilter) => {
        return sFilter.key === key && sFilter.value === value;
      });

      return index >= 0;
    },
    addSearch() {
      var index = _.findIndex(this.selectedFilters, (sFilter) => {
        return sFilter.key === 'search';
      });

      if (index >= 0) {
        if (this.search.length === 0) {
          this.removeFilter(index);
        } else {
          this.$set(this.selectedFilters, index, {
            key: 'search',
            label: this.search,
            value: this.search,
          });
        }
      } else if (this.search.length > 0) {
        this.selectedFilters.push({
          key: 'search',
          label: this.search,
          value: this.search,
        });
      }
    },
    toggleFilter(filter, filterobj) {
      var index = _.findIndex(this.selectedFilters, (sFilter) => {
        return sFilter.key === filter && sFilter.value === filterobj.value;
      });

      if (index >= 0) {
        this.selectedFilters.splice(index, 1);
      } else {
        this.selectedFilters.push({
          key: filter,
          value: filterobj.value,
          label: filterobj.name,
        });
      }
    },
    toggleFilterSearch(filter, event) {
      if (event.target.value) {
        var fuse = new Fuse(this.filters[filter].data, {
          threshold: 0.2,
          includeScore: false,
          useExtendedSearch: true,
          keys: ['name'],
        });
        this.filters[filter].visible = fuse.search(event.target.value).map((result) => {
          return result.item;
        });
      } else {
        this.filters[filter].visible = this.filters[filter].data;
      }
    },
    removeFilter(index) {
      this.selectedFilters.splice(index, 1);
    },
    bulkDelete() {
      var accept = confirm('Weet u zeker dat u de geselecteerde artikelen wilt verwijderen?');
      if (accept === true) {
        axios
          .post(route('posts.bulk-delete'), {
            posts: this.selectedPosts.map((post) => {
              return {
                blog_id: post.blog.id,
                post_id: post.id,
              };
            }),
          })
          .then((response) => {
            if (response.status == 200 && response.data) {
              if (response.data.success) {
                this.$notify({
                  group: 'main',
                  type: 'success',
                  title: `Geselecteerde artikelen zijn verwijdert`,
                });

                this.selectedPosts = [];
                window.location.reload();
              }
            }
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.filters-wrapper {
  .search-wrapper {
    height: 80px;
    background: white;
    padding: 0 30px;
    border: 1px solid #eaeaea;
    border-radius: 40px;

    .tags {
      .tag {
        height: 40px;
        padding: 0 15px;
        margin: 0 10px 0 0;
        background: #de7a01;
        color: white;
        border-radius: 6px;
        line-height: 40px;
        font-size: 14px;
        font-weight: bold;
        transition: background 0.3s ease;

        i {
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }

    input {
      height: 70px;
      font-size: 20px;
      border: none;
      outline: none;

      &:focus {
        outline: none;
        box-shadow: none;
      }
    }
  }

  .filters {
    .filter {
      .block-content {
        max-height: 250px;
        overflow-x: hidden;
        overflow-y: auto;
      }
    }
  }
}

@media (max-width: 992px) {
  .sites-wrapper {
    padding-bottom: 80px;
  }
}

.bulk-bar-wrapper {
  position: fixed;
  left: 0;
  bottom: 20px;
  width: 100%;
  max-width: 1920px;
  pointer-events: none;

  .bulk-bar {
    // min-width: 340px;
    height: 60px;
    padding: 10px 15px;
    border-radius: 8px;
    box-shadow: 0 0.5rem 2.5rem #e6e6e6;
    z-index: 3;
    pointer-events: all;

    > * {
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: center;
      border-right: 1px solid white;

      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
        border: none;
      }
    }

    .bulk-count {
      color: white;
      padding: 0 15px;
    }

    .bulk-actions {
      .bulk-action {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: white;
        padding: 0 15px;
        border-right: 1px solid white;

        i {
          font-size: 20px;
          margin-bottom: 5px;
        }

        .bulk-action-name {
          font-size: 12px;
          margin-bottom: -5px;
        }

        &:last-child {
          border: none;
        }

        &:hover {
          color: darken(white, 20%);
        }
      }
    }
  }
}
</style>
